import { render, staticRenderFns } from "./CateringPage.vue?vue&type=template&id=771f167d&scoped=true&"
import script from "./CateringPage.vue?vue&type=script&lang=js&"
export * from "./CateringPage.vue?vue&type=script&lang=js&"
import style0 from "./CateringPage.vue?vue&type=style&index=0&id=771f167d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f167d",
  null
  
)

export default component.exports